/**
 * Fordert ein kurzlebiges, ressourcengebundenes Download-Ticket an (siehe
 * backend/services/download_ticket_service.py) und baut daraus die
 * iframe-/img-taugliche Vorschau-URL. Ersetzt das Session-JWT im
 * Query-String fuer alle <iframe>/<img>-Vorschauen, die keinen
 * Authorization-Header setzen koennen.
 *
 * @param {string} ticketIssueUrl authentifizierter GET-Endpunkt, der ein Ticket liefert
 * @param {string} downloadUrl die eigentliche Download-/Vorschau-URL ohne Ticket
 * @param {HeadersInit} headers Authorization-Header fuer den Ticket-Issue-Request
 * @returns {Promise<string>} downloadUrl inkl. angehaengtem ?ticket=
 */
export async function holePreviewUrl(ticketIssueUrl, downloadUrl, headers) {
  const res = await fetch(ticketIssueUrl, { headers });
  if (!res.ok) {
    const fehler = new Error('Vorschau-Ticket konnte nicht angefordert werden');
    fehler.status = res.status;   // 404 = Original nicht verfuegbar (kein Ticket fuer eine fehlende Datei)
    throw fehler;
  }
  const data = await res.json();
  const trenner = downloadUrl.includes('?') ? '&' : '?';
  return `${downloadUrl}${trenner}ticket=${encodeURIComponent(data.ticket)}`;
}
